import * as React from 'react';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers/';
import strings from "./../../utils/StringManager";
import { DateType } from '@date-io/type';
import './QdDatePickers.css';
import { minCalculate, maxCalculate, addEventInputsChange, removeEventInputsChange } from './MinMaxCalculator';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';
import lang from "./Lang";
import createCustomEvent from '../../utils/createCustomEvent';
import moment from 'moment';

export interface Props {
	id?: string,
	value: DateType,
	name?: string,
	onChange?: (date: any) => void,
	minDate?: string,
	maxDate?: string,
	error?: string,
	label?: string,
	disabled?: boolean,
	maxDateMessage?: string,
	minDateMessage?: string,
}

interface IState {
	value: DateType,
	minDate?: ParsableDate,
	maxDate?: ParsableDate,
	disabled?: boolean,
}

export default class QdDatePicker extends React.Component<Props, IState> {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			minDate: minCalculate(props.minDate),
			maxDate: maxCalculate(props.maxDate),
			disabled: props.disabled,
		}

		this.inputRef = React.createRef<HTMLInputElement>();
	}

	inputRef: React.RefObject<HTMLInputElement>

	componentDidMount() {
		addEventInputsChange(this.props.minDate, this.handleChangeMinValue.bind(this));
		addEventInputsChange(this.props.maxDate, this.handleChangeMaxValue.bind(this));

		
		this.inputRef.current.addEventListener("changeValue", e => {
			const value: string = e["eventValue"];
			this.setState({
				value: !!value ? moment(value) : null
			});

			if (this.props.onChange)
				this.props.onChange(moment(value));
		});

		this.inputRef.current.addEventListener("disable", e => {
			this.setState({ disabled: e["eventValue"] });
		});
	}

	componentWillUnmount() {
		removeEventInputsChange(this.props.minDate, this.handleChangeMinValue.bind(this));
		removeEventInputsChange(this.props.maxDate, this.handleChangeMaxValue.bind(this));
	}

	handleChangeMinValue() {
		this.setState({
			minDate: minCalculate(this.props.minDate),
		})
	}

	handleChangeMaxValue() {
		this.setState({
			maxDate: maxCalculate(this.props.maxDate),
		})
	}

	handleOnChange(date) {
		this.setState({ value: date }, this.runChangeEvent.bind(this))
		if (this.props.onChange)
			this.props.onChange(date);
	}

	runChangeEvent() {
		const event = createCustomEvent('change', true, false);
		this.inputRef.current.dispatchEvent(event);
	}
	
	render() {
		let isoValue = "";
		if (this.state.value) {
			isoValue = this.state.value.toISOString();
		}

		let className = "input-picker";
		if (this.props.error) {
			className += " input-validation-error";
		};

		return <div className="qd-control-datetime-picker">
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<input ref={this.inputRef} type="hidden" name={this.props.name} value={isoValue} id={this.props.id} />
				<KeyboardDatePicker
					variant="inline"
					inputVariant="outlined"
					className="input-picker-root"
					autoOk
					value={this.state.value}

					minDate={this.state.minDate}
					maxDate={this.state.maxDate}
					disabled={this.state.disabled}
					maxDateMessage={lang.getDefaultByPrefix(this.props, "maxDateMessage", "maxDateMessage")}
					minDateMessage={lang.getDefaultByPrefix(this.props, "minDateMessage", "minDateMessage")}
					onError={function () { console.log("DatePicker Error:", arguments) }}
					onChange={this.handleOnChange.bind(this)}
					animateYearScrolling
					format={(window as any).qdesk.settings.dateFormat}
					invalidDateMessage={strings.get("invalidDateMessage")}
					label={this.props.label}
					InputProps={{
						className: className
					}}
				/>
			</MuiPickersUtilsProvider>
		</div>
	}
}